/// <amd-module name="Artifacts/Connect/tools/IToolConnectProps" />
import { PackagingService, TfsService } from "Artifacts/Connect/services/PackagingService";
import { IProtocol } from "Artifacts/Connect/types";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IToolConnectProps<TProtocol extends IProtocol> {
  pageContext: IVssPageContext;
  protocol: TProtocol;
  feed: ICombinedFeedView;
  packagingService: PackagingService;
  tfsService: TfsService;
}
